<!-- release-notes.component.html -->
<div class="row">
  <div class="columns small-12 medium-10 medium-offset-1">
    <h2 class="page-heading">Release Notes</h2>
  </div>
</div>
<div class="row release-notes-container">
  @for (release of releases; track release) {
    <div class="release-card columns small-12 medium-10 medium-offset-1">
      <div class="release-header" (click)="toggleExpand(release)">
        <div class="version-date">
          <span class="date">{{release.date}}</span>
        </div>
        <div class="expand-icon" [class.expanded]="release.expanded">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M7 10L12 15L17 10" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </div>
      </div>
      <div class="release-details" [class.expanded]="release.expanded">
        <h2 class="version">Here's what's new in {{release.version}}</h2>
        <div class="release-summary">
          <p>{{release.summary}}</p>
        </div>
        @if (release.features.length > 0) {
          <div class="changes-section">
            <!-- <span class="icon">🚀</span>  -->
            <h3>New Features</h3>
            <ul>
              @for (item of release.features; track item) {
                <li>{{item}}</li>
              }
            </ul>
          </div>
        }
        @if (release.improvements.length > 0) {
          <div class="changes-section">
            <!-- <span class="icon">🔧</span> -->
            <h3> Improvements</h3>
            <ul>
              @for (item of release.improvements; track item) {
                <li>{{item}}</li>
              }
            </ul>
          </div>
        }
        @if (release.bugfixes.length > 0) {
          <div class="changes-section">
            <!-- <span class="icon">🐛</span> -->
            <h3> Bug Fixes</h3>
            <ul>
              @for (item of release.bugfixes; track item) {
                <li>{{item}}</li>
              }
            </ul>
          </div>
        }
        @if (release.breaking.length > 0) {
          <div class="changes-section">
            <h3><span class="icon warning">⚠️</span> Breaking Changes</h3>
            <ul class="breaking">
              @for (item of release.breaking; track item) {
                <li>{{item}}</li>
              }
            </ul>
          </div>
        }
      </div>
    </div>
  }
</div>
